export interface ThemeState {
  theme: Theme
}

export interface ThemeContextProps extends ThemeState {
  setTheme: (theme: Theme) => void
  toggleTheme: () => void
}

export type Theme = 'light' | 'dark'

export enum ThemeActionType {
  SET_THEME = '[THEME] Set Theme',
  TOGGLE_THEME = '[THEME] Toggle Theme',
}
